import axios from "axios";
import config from "../../../../../config/config.json";
import {useToast} from "vue-toastification";

export default {
    state: {},
    actions: {
        featCat: async ({commit}, data) => {
            return new Promise((resolve, reject) => {
                axios.get('/categories')
                    .then(function (res) {
                        return resolve(res.data.data.data);
                    })
                    .catch(function (errors) {
                        console.log(errors);
                    });
            });
        },

        btn_delete: async ({commit}, data) => {
            return new Promise((resolve, reject) => {
                const toast = useToast();
                axios.get(data)
                    .then(function (response) {
                        if (response.data.status) return toast.success(response.data.messages);
                    })
                    .catch(function (error) {
                        if (error.response.status === 422) {
                            Object.values(error.response.data.errors).forEach(function (val, key) {
                                toast.error(val[0]);
                            });
                        }
                        if (error.response.status === 404) {
                            toast.error(error.response.data.messages);
                        }
                    });
            });
        },
        getCat: async ({commit}, data) => {
            return new Promise((resolve, reject) => {
                axios.get(data)
                    .then(function (res) {
                        return resolve(res);
                    })
                    .catch(function (error) {
                        return reject(error)
                    });
            });
        },

    }
}